import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { getBidderByUuid, updateBidderForEvent } from "services";
import BidderData from "../../bidder/kyc/bidderData";
import { ButtonBase } from "@reusejs/react";
import PDFViewer from "./PDFViewer";
import RemarkModal from "./RemarkModal";

export default function ViewBidder() {
  const router = useRouter();
  const { id, for_event } = router.query;
  const [bidder, setBidder] = useState<any>(null);
  const [remark, setRemark] = useState<string>("");
  const [modal, setModal] = useState<boolean>(false);
  const [disabledBtn, setDisabledBtn] = useState<boolean>(false);

  useEffect(() => {
    if (for_event) {
      (async () => {
        await init(id);
      })();
    }
    return () => {
      if (for_event) {
        return;
      }
    };
  }, [id, for_event]);

  const init = async (bidder_uuid: any) => {
    const bidderData: any = await getBidderByUuid(bidder_uuid);
    setBidder(bidderData);
  };

  const rejectReason = async (payload: any) => {
    payload["status"] = "rejected";
    payload["remarks"] = remark;
    await updateBidderForEvent(payload);
  };

  const acceptReason = async (payload: any) => {
    payload["status"] = "verified";
    await updateBidderForEvent(payload);
  };

  return (
    <div className="flex flex-col w-full p-12 relative">
      <div className="flex w-full">
        <div className="flex w-full">
          <div className="flex flex-col">
            <div className="w-1/2 text-4xl text-blue-600 font-extrabold dark:text-red-600">
              Bidder
            </div>
            <BidderData data={bidder} />
          </div>
        </div>
      </div>
      {process.env.NEXT_PUBLIC_ENABLE_FEATURE === "true" && (
        <>
          <div className="flex flex-col justify-end items-center w-full gap-2 w-full px-6">
            <div className="w-full right side w-full">
              <PDFViewer
                pdf_url={
                  bidder?.esigned_data?.esign_response?.finalSignedContract
                    ? bidder?.esigned_data?.esign_response?.finalSignedContract
                    : bidder?.esigned_data?.signer_response
                        ?.signerSignedContract
                }
              />
            </div>
            {bidder?.status?.toLowerCase() === "verified" ||
            bidder?.status?.toLowerCase() === "rejected" ||
            !bidder?.esigned_data?.esign_response
              ?.finalSignedContract ? null : (
              <div className="flex w-full justify-end">
                <div className=" items-center py-3 text-right  ">
                  <ButtonBase
                    buttonBaseClasses={{
                      backgroundColor: "bg-green-600",
                    }}
                    type="submit"
                    label={"Accept"}
                    onClick={() => {
                      setDisabledBtn(true);
                      acceptReason(bidder);
                    }}
                    disabled={disabledBtn}
                  />
                </div>
                <div className="flex items-center justify-start py-3 text-right sm:px-6">
                  <ButtonBase
                    buttonBaseClasses={{
                      backgroundColor: "bg-red-600",
                    }}
                    type="submit"
                    label={"Reject"}
                    onClick={() => setModal(true)}
                  />
                </div>
              </div>
            )}
          </div>
          {modal && (
            <RemarkModal
              remark={remark}
              setModal={setModal}
              setRemark={setRemark}
              callback={rejectReason}
              bidderData={bidder}
            />
          )}
        </>
      )}
    </div>
  );
}
